import { render, staticRenderFns } from "./ClientePage.vue?vue&type=template&id=38258508"
import script from "./ClientePage.vue?vue&type=script&lang=js"
export * from "./ClientePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports